export default {"src":"/_next/static/media/favicon.5c95b06a.ico","height":128,"width":128,"blurWidth":0,"blurHeight":0};